import React from "react";
import { cssVars } from "@sscs/ui/styles";
const ValidIcon = () => (React.createElement("svg", { width: "100%", height: "100%", viewBox: "0 0 16 14", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", { d: "M5.08471 10.58L1.29164 6.41L0 7.82L5.08471 13.41L16 1.41L14.7175 0L5.08471 10.58Z", fill: cssVars.analysis_pass_fill })));
const InvalidIcon = () => (React.createElement("svg", { width: "100%", height: "100%", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", { d: "M16 1.61143L14.3886 0L8 6.38857L1.61143 0L0 1.61143L6.38857 8L0 14.3886L1.61143 16L8 9.61143L14.3886 16L16 14.3886L9.61143 8L16 1.61143Z", fill: cssVars.analysis_fail })));
const ValidationIcon = ({ isValid, }) => {
    if (isValid)
        return React.createElement(ValidIcon, null);
    else
        return React.createElement(InvalidIcon, null);
};
export default ValidationIcon;
//# sourceMappingURL=ValidationIcon.js.map